// removed by extract-text-webpack-plugin
module.exports = {"col2":"_3yTH","centerOnMobile":"_2I2S"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Col2TextText/Col2TextText.scss
// module id = qWW6
// module chunks = 0